// extracted by mini-css-extract-plugin
module.exports = {"flagEmoji":"Flag_flagEmoji__mOeDl"};